import { render, staticRenderFns } from "./DataMigration.vue?vue&type=template&id=1be9f00e&scoped=true"
import script from "./DataMigration.vue?vue&type=script&lang=js"
export * from "./DataMigration.vue?vue&type=script&lang=js"
import style0 from "./DataMigration.vue?vue&type=style&index=0&id=1be9f00e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be9f00e",
  null
  
)

export default component.exports